import React from "react";
import { useI18n, LOCALES } from "../../i18n";

export default function Footer() {
  const { t, locale, setLocale } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer id="markets" className="bg-brand-ink text-brand-ivory" data-testid="site-footer">
      <div className="container-x py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center">
              <img
                src={`${process.env.PUBLIC_URL}/white-logo.png`}
                alt="Vinculum"
                className="h-8 md:h-9 w-auto"
              />
            </a>
            <p className="mt-5 text-brand-ivory/70 text-sm leading-relaxed max-w-sm">
              {t("footer.tag")}
            </p>
            <p className="mt-6 text-xs uppercase tracking-[0.18em] text-brand-terracotta">
              {t("footer.markets")}
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.18em] text-brand-ivory/50">{t("footer.product")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="#why" data-testid="footer-link-why">{t("footer.l_why")}</a></li>
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="#features" data-testid="footer-link-features">{t("footer.l_features")}</a></li>
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="#pricing" data-testid="footer-link-pricing">{t("footer.l_pricing")}</a></li>
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="#how" data-testid="footer-link-how">{t("footer.l_how")}</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.18em] text-brand-ivory/50">{t("footer.company")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="#lead" data-testid="footer-link-contact">{t("footer.l_contact")}</a></li>
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="#lead" data-testid="footer-link-book">{t("footer.l_book")}</a></li>
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="https://www.thevinculum.de" target="_blank" rel="noopener noreferrer" data-testid="footer-website">www.thevinculum.de</a></li>
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory break-all" href="mailto:Kshitij.shah@thevinculum.de" data-testid="footer-email">Kshitij.shah@thevinculum.de</a></li>
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="tel:+919712913584" data-testid="footer-phone">+91 97129 13584</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.18em] text-brand-ivory/50">{t("footer.legal")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="#privacy">{t("footer.l_privacy")}</a></li>
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="#terms">{t("footer.l_terms")}</a></li>
              <li><a className="text-brand-ivory/85 hover:text-brand-ivory" href="#gdpr">{t("footer.l_gdpr")}</a></li>
            </ul>
            <div className="mt-6 flex flex-wrap gap-2">
              {LOCALES.map((l) => (
                <button
                  key={l.code}
                  onClick={() => setLocale(l.code)}
                  data-testid={`footer-lang-${l.code}`}
                  className={`px-3 py-1 rounded-full text-[11px] uppercase tracking-[0.18em] border transition-colors ${
                    locale === l.code
                      ? "bg-brand-ivory text-brand-forest border-brand-ivory"
                      : "border-brand-ivory/30 text-brand-ivory/70 hover:text-brand-ivory"
                  }`}
                >
                  {l.code}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-brand-ivory/15 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-xs text-brand-ivory/55">
          <p>© {year} {t("footer.copyright")}</p>
          <p className="uppercase tracking-[0.18em]">GDPR compliant · No setup fee · Cancel any time</p>
        </div>
      </div>
    </footer>
  );
}
